import { supabase } from '@/lib/supabase';

export type EmailChannel = { id: string; provider: string; from_email: string | null; from_name: string | null;
  status: string; is_primary: boolean; updated_at: string | null; has_key: boolean };
export type EmailConfiguration = { channel: EmailChannel | null; platform_available: boolean; platform_sender: string };
export type EmailDraft = { organization_id: string; id: string | null; updated_at: string | null;
  from_email: string; from_name: string; key_source: 'platform' | 'custom' | 'keep'; api_key?: string };
const errors: Record<string, string> = {
  unauthorized: 'נדרשת התחברות מחדש.', forbidden: 'הפעולה זמינה למנהל המערכת בלבד.',
  server_not_configured: 'שירות ניהול האימייל טרם הוגדר בשרת.',
  ambiguous_channels: 'נמצאו כמה ערוצי אימייל לארגון. נדרש בירור לפני שינוי.',
  unsupported_existing_provider: 'הערוץ הקיים משתמש בספק אחר. לא בוצע שינוי.',
  stale_channel: 'ההגדרה השתנתה. יש לרענן לפני שמירה.', save_failed_refresh: 'השמירה לא הושלמה. יש לרענן ולבדוק לפני ניסיון נוסף.',
  domain_not_verified: 'דומיין השולח אינו מאומת לשליחה בחשבון Resend הזה.',
  domain_check_unavailable: 'לא ניתן לבדוק את הדומיין. נדרש מפתח Resend עם הרשאת קריאת דומיינים.',
  key_required: 'נדרש מפתח שליחה תקין.', invalid_sender: 'יש למלא שם שולח וכתובת אימייל תקינים.',
};
async function call<T>(body: Record<string, unknown>): Promise<T> {
  const { data } = await supabase.auth.getSession();
  if (!data.session?.access_token) throw new Error(errors.unauthorized);
  const res = await fetch('https://mzalzjtsyrjycaxolldv.supabase.co/functions/v1/admin-email-channel', {
    method: 'POST', headers: { Authorization: `Bearer ${data.session.access_token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const result = await res.json().catch(() => null);
  if (!res.ok) throw new Error(errors[result?.error] ?? (res.status === 404 ? 'שירות ניהול האימייל טרם פורסם.' : 'הפעולה לא הושלמה. נסו לרענן.'));
  return result as T;
}
export const emailChannelsApi = {
  get: (organization_id: string) => call<EmailConfiguration>({ action: 'get', organization_id }),
  save: (draft: EmailDraft) => call<{ channel: EmailChannel }>({ ...draft, action: 'save' }),
  verify: (draft: EmailDraft) => call<{ verification: { domain: string; status: string } }>({ ...draft, action: 'verify' }),
  suspend: (organization_id: string, channel: EmailChannel) => call<{ channel: EmailChannel }>({ action: 'suspend', organization_id, id: channel.id, updated_at: channel.updated_at }),
};
